import React, { useEffect, useState } from "react";
import {useNavigate, useParams} from "react-router-dom";
import API from "../../api/axios";

export default function VerifyPaymentSuccess() {
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const { id } = useParams(); // Get the ID from URL params
    useEffect(() => {
        handleSubmit(); // Call it on component mount
    }, []);

    const handleSubmit = async () => {

        try {
            const res = await API.post("/activateaccount", {
                id:id
                },
                {  headers: {
                        "Content-Type": "application/json",
                    },


                }      );
            if (res.data.status) {
                localStorage.setItem("user", JSON.stringify(res.data.data?.user));

            } else {
                setError(res.data.message);
            }
        } catch (err) {
            console.error(err);
            setError("Login failed. Please try again.");
        }
    };
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-[#F7EBFC] px-4">
            <img src="https://verify.18verified.com/logo.png" alt="Logo" className="max-w-[200px] w-full mb-6" />
            <div className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-md border border-[#E3BCF4]" >
                <h2 className="text-sm sm:text-base text-center mb-6 text-[#652F9B]">You have now successfully verified that you are over the age of 18! You can now login and browse freely. Your logins will work across all participanting platforms, so no need to get verified again!.</h2>
            </div>
        </div>
    );
}
